import Typography from 'typography'

// Full config options can be found at http://kyleamathews.github.io/typography.js/

const typography = new Typography({
    baseFontSize: '16px',
    baseLineHeight: 1.4,
    scaleRatio: 2,
    headerFontFamily: [
        'Gilroy',
        'sans-serif',
    ],
    bodyFontFamily: [
        'Lora',
        'sans-serif',
    ],
    headerWeight: '500',
    bodyWeight: '400',
    boldWeight: '700',
})

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js